import { render, staticRenderFns } from "./BetalokLab.vue?vue&type=template&id=bf682782&scoped=true"
import script from "./BetalokLab.vue?vue&type=script&lang=js"
export * from "./BetalokLab.vue?vue&type=script&lang=js"
import style0 from "./BetalokLab.vue?vue&type=style&index=0&id=bf682782&prod&lang=scss&scoped=true"
import style1 from "./BetalokLab.vue?vue&type=style&index=1&id=bf682782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf682782",
  null
  
)

export default component.exports